import { types } from '../../../types/types';

export const reducerPesquisaPedidosItens = (state = {}, action = {}) => {
    
    let result = {};

    switch (action.type) {
        case types.PRODUTOS.PESQUISA_PEDIDOSITENS:
            result = action.payload;
            break;
    
        default:
            result = state;
            break;
    }

    return result;
}